const setCategory = (state, payload) => {
    if (payload) {
        payload.map(e => {
            e.is_open = false
            e.children.map(e => {
                e.is_open = false
            })
        })
    }

    state.category = payload;
};
export default {
    setCategory
};